import { EVENT_COLORS, hexToRgb } from './colorPalette.js'

export const EventColors = Object.freeze(
  EVENT_COLORS.map((c) => ({ ...hexToRgb(c.light), name: c.colorName }))
)

export const EventColorNames = EventColors.map((c) => c.name)

export const getEventColorByName = (name) => {
  const entry = EVENT_COLORS.find((c) => c.colorName === name)
  if (!entry) {
    return null
  }

  const { red, green, blue } = hexToRgb(entry.light)

  return { red, green, blue, rgb: `rgb(${red},${green},${blue})` }
}
